import { useEffect } from "react";
import initializeFullSearchWindow from "../features/Search";
export const useSearch = () => {
    useEffect(() => {
        initializeFullSearchWindow();
    }, []);
};
